import axios from 'axios';
import { BASE_URL } from '../Constants/Api';

const API_URL = BASE_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const getDocuments = async (employeeId, status) => {
  try {
    const response = await api.get(`/documents`, {
      params: { employeeId, status },
    });
    return response.data || [];
  } catch (error) {
    console.error("Failed to fetch documents:", error);
    throw new Error("Failed to fetch documents");
  }
};

export const uploadDocument = async (employeeId, documentType, issueDate, expiryDate, statusCode, file) => {
  try {
    // Create FormData object
    const formData = new FormData();
    
    // Append all the required fields
    formData.append('file', file);
    formData.append('employeeId', employeeId);
    formData.append('documentType', documentType);
    
    // Only append dates if they exist
    if (issueDate) formData.append('issueDate', issueDate);
    if (expiryDate) formData.append('expiryDate', expiryDate);
    
    formData.append('statusCode', statusCode);

    // Make the POST request with the FormData
    // Make sure the API endpoint matches your backend
    const response = await api.post('/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data;
  } catch (error) {
    console.error("Raw error from uploadDocument API:", error);
    console.error("Failed to upload document:", error.response?.data || error.message);
    throw error; // Re-throw the original error object
  }
};

export const deleteDocument = async (employeeId, docType) => {
  try {
    const response = await api.delete("/documents/delete", {
      params: { employeeId, docType }
    });
    
    return response.data;
  } catch (error) {
    console.error("Failed to delete document:", error);
    throw new Error("Failed to delete document");
  }
};






